'use client';
import {createContext, useContext, useEffect, useState} from 'react';
import {addItemsToLocalStorage, getItemsFromLocalStorage} from '@/libs/local-storage.util';

const CommonDataContext = createContext(null);

export default function CommonDataContextProvider({ value, children }) {
  const [storedCommon, setStoredCommon] = useState(value);
  
  useEffect(() => {
    if (value) {
      addItemsToLocalStorage('common', value);
    }
    const commonFromLocalStorage = getItemsFromLocalStorage('common');
    
    if (commonFromLocalStorage) {
      setStoredCommon(commonFromLocalStorage);
    }
  }, [value]);

  return (
    <CommonDataContext.Provider
        value={{
          common: storedCommon,
        }}
    >{children}</CommonDataContext.Provider>
  );
}

export const useCommonDataContext = () => {
  return useContext(CommonDataContext);
};
